import { magellanClient } from '../../../infra/axios';
import type {
  FindAllArchivedBidResponseDocumentsResponseDTO,
  UpdateBidResponseDocumentRequestDTO,
  UpdateBidResponseDocumentResponseDTO,
} from './dto';

export async function getAllArchivedBidResponseDocuments(
  bidResponseId: number,
): Promise<FindAllArchivedBidResponseDocumentsResponseDTO> {
  const response =
    await magellanClient.get<FindAllArchivedBidResponseDocumentsResponseDTO>(
      `bidResponses/${bidResponseId}/bidResponseDocuments/archived`,
    );

  return response.data;
}

export async function updateBidResponseDocument({
  bidResponseId,
  bidResponseDocumentId,
  payload,
}: {
  bidResponseId: number;
  bidResponseDocumentId: number;
  payload: UpdateBidResponseDocumentRequestDTO;
}): Promise<UpdateBidResponseDocumentResponseDTO> {
  const response =
    await magellanClient.put<UpdateBidResponseDocumentResponseDTO>(
      `bidResponses/${bidResponseId}/bidResponseDocuments/${bidResponseDocumentId}`,
      payload,
    );

  return response.data;
}

export async function archiveBidResponseDocument({
  bidResponseId,
  bidResponseDocumentId,
}: {
  bidResponseId: number;
  bidResponseDocumentId: number;
}): Promise<UpdateBidResponseDocumentResponseDTO> {
  const response =
    await magellanClient.put<UpdateBidResponseDocumentResponseDTO>(
      `bidResponses/${bidResponseId}/bidResponseDocuments/${bidResponseDocumentId}/archive`,
    );

  return response.data;
}

export async function restoreBidResponseDocument({
  bidResponseId,
  bidResponseDocumentId,
}: {
  bidResponseId: number;
  bidResponseDocumentId: number;
}): Promise<UpdateBidResponseDocumentResponseDTO> {
  const response =
    await magellanClient.put<UpdateBidResponseDocumentResponseDTO>(
      `bidResponses/${bidResponseId}/bidResponseDocuments/${bidResponseDocumentId}/recover`,
    );

  return response.data;
}
